import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { categories } from "@/mocks/categories";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 max-w-portal w-full mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <p className="font-heading text-7xl md:text-9xl font-black text-primary-200 select-none">
          404
        </p>
        <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-4">
          这条剧情线断了
        </h1>
        <p className="text-sm text-foreground-600 mt-3">
          没有找到 <span className="font-mono text-foreground-800">{location.pathname}</span> 对应的页面，
          回到首页继续看幕后故事吧。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 mt-7 px-6 py-3 rounded-md bg-foreground-950 text-background-50 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-accent-700 transition-colors"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
          返回首页
        </Link>

        <div className="mt-12 pt-8 border-t border-background-200">
          <h2 className="font-heading text-base font-bold text-foreground-950 mb-4">
            或许你想看看这些栏目
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background-100 border border-background-200 text-sm font-medium text-foreground-800 hover:border-primary-500 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <i className={`${cat.icon} text-lg text-secondary-700`} />
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}